import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-redirect-dialog',
    templateUrl: './redirect-dialog.component.html',
    styleUrls: ['./redirect-dialog.component.css'],
    standalone: false
})
export class RedirectDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public alertData: any,
    private dialogRef: MatDialogRef<RedirectDialogComponent>, private router: Router
  ) { }

  ngOnInit(): void { }

  onAction(action: string): void {
    if (action === 'view') {
      this.dialogRef.close(); // close dialog first
      this.router.navigate(['/reports/inventory/missing-item-report']); // adjust route if needed
    } else {
      this.dialogRef.close();
    }
  }
  

}
